import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './khb.component.html',
  styleUrls: ['./khb.component.css']
  
})
export class AppComponent implements OnInit {
  title = 'app';
  logidin = true;
  showLoader: boolean;

  constructor() { }

  loginChange(data) {
   
    if (!data)
      this.logidin = false;
    else
      this.logidin = true;
  }


  // $(document).ready(function(){
  //   if($('input.custom-field').val() != ""){
  //       $(this).sibling('label').addClass('label-mat');
  //   }else{
  //     $(this).sibling('label').removeClass('label-mat');
  //   }
  // });
  
  ngOnInit() {
    let accessToken = localStorage.getItem('accessToken');
    if (accessToken != null && accessToken != "" && typeof accessToken != 'undefined'){
      this.logidin = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/khb.component.ts